/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export function get2025HolidayStaysDates() {
    const thanksgiving = {
        startDate: new Date('2025-11-28T00:00:00Z'),
        endDate: new Date('2025-11-30T00:00:00Z'),
    };
    const christmas = {
        startDate: new Date('2025-12-26T00:00:00Z'),
        endDate: new Date('2025-12-28T00:00:00Z'),
    };
    const newYear = {
        startDate: new Date('2026-01-02T00:00:00Z'),
        endDate: new Date('2026-01-04T00:00:00Z'),
    };

    // Determine which holiday to use based on today's date (UTC)
    const now = new Date();

    // Helper to get the next holiday after today
    const holidays = [thanksgiving, christmas, newYear].map((h) => ({
        ...h,
        start: h.startDate,
        end: h.endDate,
    }));

    let selectedHoliday = holidays.find((h) => now < h.start);

    // If none found, default to newYear
    if (!selectedHoliday) {
        selectedHoliday = holidays[2];
    }

    // Set startDate and endDate to the selected holiday
    const startDate = selectedHoliday.start;
    const endDate = selectedHoliday.end;

    return [startDate, endDate];
}
